import _get from 'lodash/get'
import _reduce from 'lodash/reduce'
import { map as mapPromise } from 'bluebird'
import { getExact } from 'services/tiles'

export async function getMany (seriesIds, options = {}) {
  const {
    auth,
    language,
  } = options

  // Fetch all data concurrently
  const responses = await mapPromise(seriesIds, async (seriesId) => {
    try {
      const data = await get(seriesId, { auth, language })
      return { seriesId, data }
    } catch (error) {
      return { seriesId, error }
    }
  })

  // Return { error } or { data } keyed by seriesId
  const pmSeries = _reduce(responses, (acc, response) => {
    if (response.error) {
      acc[response.seriesId] = { error: response.error }
    } else if (response.data) {
      acc[response.seriesId] = { data: response.data }
    }
    return acc
  }, {})

  return pmSeries
}

export async function get (seriesId, options = {}) {
  const {
    language,
    auth,
  } = options
  const results = await getExact({
    id: seriesId, language, auth,
  })
  const tile = _get(results, 'titles[0]', {})
  if (tile.nid < 1) {
    throw new Error(`Bad series ${seriesId}, response nid: ${tile.nid}`)
  }
  return tile
}
